import {useContext} from 'react';
import ControlsContextMobile from '../contextCreate/ControlsContextMobile';

const useControls = () => {
	return useContext(ControlsContextMobile);
};

export default useControls
